export function slugifySectionId(value = "") {
  return String(value).toLowerCase().trim().replace(/\s+/g, "-");
}

export function stripHtml(html = "") {
  return String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function hasServiceContent(service) {
  if (!service) return false;

  const hasItems = Array.isArray(service.itemsList) && service.itemsList.length > 0;
  const hasTitle =
    (service.titleFirst && service.titleFirst.trim() !== "") ||
    (service.titleLast && service.titleLast.trim() !== "");
  const hasDescription =
    service.description && service.description.trim() !== "";

  return hasItems || hasTitle || hasDescription;
}

export const DEALS_CATEGORIES = [
  {
    text: "Holidays",
    img: "/assets/icons/holidayicon.svg",
    dataKey: "Holiday",
  },
  {
    text: "Stays",
    img: "/assets/icons/staysicon.svg",
    dataKey: "Staycation",
  },
  {
    text: "Activities",
    img: "/assets/icons/activityicon.svg",
    dataKey: "Activity",
  },
];

export const DEFAULT_DEALS_FAQS = [
  {
    id: "cancel-booking",
    question: "How to cancel a booking?",
    answer:
      "To cancel a booking, contact our support team with your booking reference number. Our travel experts will guide you through the cancellation process and inform you of any applicable charges based on the provider's policy.",
  },
  {
    id: "refund-process",
    question: "What is the refund process?",
    answer:
      "Once your cancellation is confirmed, refunds are processed to your original payment method. Processing times may vary depending on your bank or payment provider, typically within 7–14 business days.",
  },
  {
    id: "apply-visa",
    question: "How to apply for a VISA?",
    answer:
      "You can apply for a visa through Next Holidays by selecting your destination and visa type on our website, or by contacting our visa specialists directly. We'll assist with documentation and submission.",
  },
  {
    id: "change-dates",
    question: "How to change travel dates?",
    answer:
      "To change travel dates, reach out to our support team with your booking details. Date changes are subject to availability and any fare or policy differences charged by the service provider.",
  },
];

export function mapApiFaqs(faqs = []) {
  if (!Array.isArray(faqs) || !faqs.length) return [];

  return faqs
    .map((item, index) => ({
      id: String(item.id || item.faqId || index),
      question: item.question || item.faqQuestion || item.title || "",
      answer: stripHtml(item.answer || item.faqAnswer || item.description || ""),
    }))
    .filter((item) => item.question && item.answer);
}
